import {useEffect,useState} from 'react';
import {AccessibilityInfo,AppState,Platform} from 'react-native';

export default function useDiagramEnvironment() {
  const [reducedMotion,setReducedMotion]=useState(false);
  const [active,setActive]=useState(AppState.currentState!=='background'&&AppState.currentState!=='inactive');
  useEffect(()=>{
    if(Platform.OS==='web') {
      const query=window.matchMedia?.('(prefers-reduced-motion: reduce)');
      const motion=()=>setReducedMotion(!!query?.matches),visibility=()=>setActive(!document.hidden);
      motion();visibility();query?.addEventListener?.('change',motion);document.addEventListener('visibilitychange',visibility);
      return ()=>{query?.removeEventListener?.('change',motion);document.removeEventListener('visibilitychange',visibility);};
    }
    let alive=true;
    Promise.resolve(AccessibilityInfo.isReduceMotionEnabled?.()).then(value=>{if(alive)setReducedMotion(!!value);}).catch(()=>{});
    const motion=AccessibilityInfo.addEventListener?.('reduceMotionChanged',setReducedMotion);
    const visibility=AppState.addEventListener('change',value=>setActive(value==='active'));
    return ()=>{alive=false;motion?.remove();visibility?.remove();};
  },[]);
  return {reducedMotion,active};
}
